import { color } from 'styles/colors'

export const baseLayout: Partial<Plotly.Layout> = {
  font: {
    family: 'Source Sans Pro, sans-serif',
    size: 12,
    color: color('maintenanceChartText')
  },
  plot_bgcolor: color('maintenanceChartBackground'),
  showlegend: false,
  autosize: true,
  margin: { t: 20, b: 40, l: 70, r: 65, pad: 0 },
  hovermode: 'x',
  yaxis: {
    side: 'bottom',
    rangemode: 'tozero',
    domain: [0, 0.09],
    fixedrange: false,
    showgrid: false,
    showticklabels: false,
    zeroline: false,
    showline: false,
    anchor: 'x'
  },
  xaxis: {
    automargin: true,
    fixedrange: true,
    showgrid: false,
    domain: [0.02, 0.89], // setting domain helps as to show multiple y-axis in the plot
    zeroline: false,
    showline: false,
    tickformat: '%d',
    ticklen: 2,
    tickcolor: 'transparent',
    type: 'date',
    tickangle: 0
  },
  annotations: [
    {
      xref: 'paper',
      yref: 'y',
      xanchor: 'right',
      x: 0,
      y: 0.09,
      text: 'alerts',
      align: 'center',
      xshift: -10,
      yshift: 0,
      visible: false,
      showarrow: false,
      captureevents: false,
      font: {
        size: 12
      }
    }
  ]
}
